import React, { useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import FreeTrialIcon from "../IconComp/freeTrial";
import { useNavigate } from "react-router-dom";
import RejectIcon from "../IconComp/rejectIcon";
import ContactButton from "../IconComp/contactButton";
import DisableIcon from "../IconComp/disableIcon";
import ActiveIcon from "../IconComp/activeIcon";
import CrossIcon from "../IconComp/crossIcon";
import { editSubscriptionStatus } from "../../features/subscription/SubscriptionSlice";
import { useDispatch } from "react-redux";

interface DisableModalProps {
  open: any;
  onClose: () => void;
}

const DisableModal: React.FC<DisableModalProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleContact = () => {
    const currentPath = window.location.pathname.replace("/pms", "");
    const targetPath = "/contactus";

    window.location.href = currentPath === "" ? targetPath : targetPath;
  };

  return (
    <Modal
      open={open}
      // onClose={onClose}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // Centers the modal
          width: "90%",
          maxWidth: 743, // Sets a fixed width for larger screens
          height: "422px",
          bgcolor: "white",
          boxShadow: 44,
          maxHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 10, sm: 0 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            alignItems: "center",
          }}
        >
          <Box>
            <DisableIcon />
          </Box>

          <Box sx={{ fontSize: "24px", color: "#1E1D22", fontWeight: 500 }}>
            Your Account Access Has Been Disabled
          </Box>
          <Box sx={{ fontSize: "12px", fontWeight: 400,  px: { xs: 0, sm: 4 } }}>
            We regret to inform you that your access to the portal has been
            disabled. If you require any clarification please feel free to
            contact our support team.
            <span
              style={{
                fontWeight: 600,
                fontSize: "14px",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              <a
                href="tel:03095558054"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                03095558054
              </a>
            </span>
          </Box>
          <Box
            onClick={handleContact}
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
              cursor: "pointer",
            }}
          >
            <ContactButton />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default DisableModal;
